import { useSelector } from 'react-redux'
import { useUsedEquipmentActions } from '../store/slices/UsedEquipmentSlice'

const useUsedEquipment = () => {
    const {
        resetUsedEquipmentFilters,
        saveUsedEquipmentFilters,
    } = useUsedEquipmentActions()
    const filters = useSelector(state => state.UsedEquipmentSlice.filters)

    return {
        resetUsedEquipmentFilters,
        saveUsedEquipmentFilters,
        filters,
    }
}

export default useUsedEquipment
